import store from "@/store";
import { UgEventTag, UgTag } from "@/store/modules/ugTag";

export function showAlert(message: string) {
  UgTag.pushEvent(UgEventTag.AlertDisplayed);
  store.dispatch("alert/showAlert", message);
}
